import * as universal from '../entries/pages/servers/_server_/databases/_database_/collections/_collection_/documents/_document_/_layout.ts.js';

export const index = 5;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/layout.svelte.js')).default;
export { universal };
export const universal_id = "src/routes/servers/[server]/databases/[database]/collections/[collection]/documents/[document]/+layout.ts";
export const imports = ["_app/immutable/nodes/5.Cmq5DvNh.js","_app/immutable/chunks/DE4zkCvd.js","_app/immutable/chunks/D0KpzAQe.js","_app/immutable/chunks/CKFcjP6K.js","_app/immutable/chunks/Dks4_8YZ.js","_app/immutable/chunks/C1G8G6MU.js"];
export const stylesheets = [];
export const fonts = [];
